export const UI_NAME = 'ui-dropdown';
